export default "__VITE_ASSET__afa7b94c__"